import { render, staticRenderFns } from "./addResurveyPage.vue?vue&type=template&id=0cec4aa0&scoped=true&"
import script from "./addResurveyPage.vue?vue&type=script&lang=tsx&"
export * from "./addResurveyPage.vue?vue&type=script&lang=tsx&"
import style0 from "./addResurveyPage.vue?vue&type=style&index=0&id=0cec4aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec4aa0",
  null
  
)

export default component.exports